import React, {lazy, Suspense} from "react";
import ReactDOM from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import App from "./App";
import { isWatchPath, isSlimPath } from "./watch/route";
import { WatchErrorBoundary } from "./watch/WatchErrorBoundary";
import { config } from "./config";
import { startMeasurement, posthog } from "./measurement/measurement";
import { ConsentChoices } from "./measurement/ConsentChoices";
import { startMetaConsent } from "./analytics/metaConsent";
import { isLargeNewPath } from "./largenew/routes";
import "./styles/interLatin.css";
import "./styles/interTightLatin.css";
import "./styles/app.scss";
import "./styles/paywall.scss";

const isStoryMediaTest = window.location.pathname.replace(/\/+$/, "") === "/test/story-media";
const isCtaGradientTest = window.location.pathname.replace(/\/+$/, "") === "/test/cta-gradients";
const CtaGradientTestPage = lazy(() => import("./pages/CtaGradientTestPage"));
const StoryMediaTestPage = lazy(() => import("./pages/StoryMediaTestPage"));
const WatchPage = lazy(() => import("./watch/WatchPage"));
const LargeNewPage = lazy(() => import("./largenew/LargeNewPage"));
const isLargeNew = isLargeNewPath(window.location.pathname);
const isWatch = isWatchPath(window.location.pathname) || isSlimPath(window.location.pathname);

if (!isStoryMediaTest && !isCtaGradientTest) { startMeasurement("funnel", config.apiBaseUrl); startMetaConsent(); }

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {isCtaGradientTest ? <Suspense fallback={<p>Loading gradients…</p>}><CtaGradientTestPage /></Suspense> : isStoryMediaTest ? <Suspense fallback={<p>Loading story media…</p>}><StoryMediaTestPage /></Suspense> : <PostHogProvider
      client={posthog}
    >
      {isLargeNew ? <WatchErrorBoundary scope="page"><Suspense fallback={<p className="story-route-loading" role="status">Loading Parables…</p>}><LargeNewPage /></Suspense></WatchErrorBoundary> : isWatch ? <WatchErrorBoundary scope="page"><Suspense fallback={<p className="story-route-loading" role="status">Loading your story…</p>}><WatchPage /></Suspense></WatchErrorBoundary> : <App />}
      <ConsentChoices />
    </PostHogProvider>}
  </React.StrictMode>
);
